import React, {useContext} from "react";
import Card from "../UI/Card";
import AppContext from "../../store/app-context";
import styles from "./QuoteListNewBrand.module.css";

const QuoteListNewBrand = (props) => {
  
  const appCtx = useContext(AppContext);

  const defaults = {
    quote_title: 'Quotes',
    home: 'Home',
    created: "Created",
    quote_id: "Quote ID",
    web_ref_id: "Web Ref ID",
    expiration: "Expiration",
    status: "Status",
    actions: "Actions"
  };

  let {
    created,
    quote_id,
    web_ref_id,
    expiration,
    status,
    actions
  } = defaults;

  if (appCtx?.bioradResources) {
    created = appCtx.bioradResources.Created ?? created;
    quote_id = appCtx.bioradResources.QuoteId ?? quote_id;
    web_ref_id = appCtx.bioradResources.WebRefId ?? web_ref_id;
    expiration = appCtx.bioradResources.Expiration ?? expiration;
    status = appCtx.bioradResources.QuoteStatus ?? status;
    actions = appCtx.bioradResources.Actions ?? actions;
  }

  return (
    <div className={styles.card}>
      <section className={styles.itemsList}>
        <div className={styles.parentWrapper}>
          <div className={styles.lrow}>
            <div className={styles.child1}>
              <span>{created}</span>
            </div>
            <div className={styles.child1}>
              <span>{quote_id}</span>
            </div>
            <div className={styles.child1}>
              <span>{web_ref_id}</span>
            </div>
            <div className={styles.child1}>
              <span>{expiration}</span>
            </div>
            <div className={styles.child1}>
              <span>{status}</span>
            </div>
            <div className={styles.child1}>
              <span>{actions}</span>
            </div>
          </div>
          <div className={styles.lrows}>{props.quoteList}</div>
        </div>
      </section>
    </div>
  );
};

export default QuoteListNewBrand;
